import { getRuntimeConfig } from '@erebus/runtime-config';

/**
 * Which way this page load signs in: cookie auth via `@erebus/http`, or the
 * legacy Java token sent as a Bearer header (PRX-1745).
 *
 * It is chosen once, at boot, because `init()` in `@erebus/http` only runs
 * once per page. Until `chooseAuthMode()` runs it is bearer mode, which keeps
 * every test that never boots the app on today's behaviour.
 *
 * Kept in its own module, not in `boot/axios`, because many tests mock
 * `boot/axios` wholesale and would lose this with it.
 */
let cookieAuth = false;

/**
 * Picks the mode for this page load and returns true for cookie auth.
 *
 * Cookie auth needs the `connectUseCookieAuth` switch. The referral page stays
 * on bearer mode even with the switch on: it signs in through legacy's second
 * factor, and the case view it shows calls both backends with that token. Go
 * accepts the legacy token when there is no cookie. The router uses normal
 * URLs, so the route is in `location.pathname`. Old `#/` links are turned
 * into paths before this runs (boot/webHistoryRedirect).
 */
export function chooseAuthMode(): boolean {
  const { connectUseCookieAuth } = getRuntimeConfig();
  cookieAuth = Boolean(connectUseCookieAuth) && !window.location.pathname.startsWith('/referral');
  return cookieAuth;
}

/**
 * Reloads the page, so boot picks the mode again. Its own function so a test
 * can stand in for it: jsdom cannot reload.
 */
export function reloadPage(): void {
  window.location.reload();
}

/** True when this page load uses cookie auth. */
export function isCookieAuthMode(): boolean {
  return cookieAuth;
}
